$.material.init();
/*$(document).on('focus', '.select2', function() {
    $(this).siblings('select:enabled').select2('open');
});*/

// document.getElementById("closePopup").addEventListener("click", function() {
//     document.getElementById("popup").style.left = "-100%";
// });

if(document.querySelector('.js-tablon')) {
  document.querySelector(".js-tablon").addEventListener("click", function() {
    document.querySelector(".tablon-anuncios").style.right = "0";
    document.querySelector('.main_content_iner').classList.add('back-tablon')
    document.querySelector('.avisos').style.display = "none"
    closeTablon(document.querySelector('.back-tablon'))
  });
  document.querySelector(".btn-close-popup").addEventListener("click", function() {
      document.querySelector(".tablon-anuncios").style.right = "-100%";
      document.querySelector('.main_content_iner').classList.remove('back-tablon')
      document.querySelector('.avisos').style.display = ""
  })
  
}

function closeTablon(item) {
    item.addEventListener('click', (e)=> {
      if (e.target.matches(".overly_inner") ) { 
        if(document.querySelector(".tablon-anuncios")) {
          document.querySelector(".tablon-anuncios").style.right = "-100%";
        } else {
          document.querySelector(".direct-chat").style.right = "-100%";
        }
        item.classList.remove('back-tablon')
        document.querySelector('.avisos').style.display = ""
      }
    })
}


window.addEventListener("load", (event) => {
  if(document.querySelector('.avisos').style.display === "none") {
    document.querySelector('.avisos').style.display = ""
  }
    console.log("page is fully loaded");
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new bootstrap.Tooltip(tooltipTriggerEl)
    })

    // document.querySelectorAll('.nav-tabs-custom').forEach(pe => {
    //   console.log(pe.querySelector('.nav-tabs'), pe.querySelector('.nav-tabs').children.length)
    //   // if( pe.querySelector('.nav-tabs').children.length === 1) {
    //   //   pe.
    //   // }
    //   if( pe.querySelector('.nav-tabs').children.length > 1) {
    //     console.log(pe.querySelectorAll('.tab-pane'), pe.querySelectorAll('.tab-pane').children)
    //     }
    // })
    // console.log(document.querySelectorAll('.nav-tabs-custom'))
    var anchoPantalla = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    if (anchoPantalla < 760) {
      if(document.querySelector('.sidebar').classList.contains('mini_sidebar')) {
          document.querySelector('.sidebar').classList.remove('mini_sidebar')
          document.querySelector('.main_content').classList.remove('full_main_content')
        }
      } 
});

  var swiper = new Swiper(".swiper-tags-acciones", {
    slidesPerView: 'auto',
    spaceBetween: 4,
    freeMode: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
  

  if(document.getElementById('btnCreateR')) {
    document.getElementById('btnCreateR').addEventListener('click', ()=> {
      if(!document.getElementById('btnCreateR').classList.contains('collapsed')) {
        document.getElementById('btnCreateR').parentElement.classList.add('grey')
      } else {
        document.getElementById('btnCreateR').parentElement.classList.remove('grey')
      }
    })
  }
  

  // menu class liactive

  if(document.getElementById('sidebar_menu')) {
    let menu =document.getElementById('sidebar_menu');
    menu.querySelectorAll('li').forEach(li => {
      if(li.classList.contains('active')) {
        li.parentElement.parentElement.classList.add('liactive')
      }
    });
  }
document.addEventListener("DOMContentLoaded", function() {
    // Obtener el elemento almacenado en localStorage (si existe)
    var menuItem = localStorage.getItem("selectedItem");

    // Si hay un elemento almacenado, seleccionarlo
    if (menuItem) {
        seleccionarItem(document.querySelector(`a[href="${menuItem}"]`));
    }
    var elementosMenu = document.querySelectorAll("#sidebar_menu li  ul a");
    elementosMenu.forEach(function(item) {
        item.addEventListener("click", function() {
            // event.preventDefault(); // Evitar el comportamiento predeterminado del enlace
            seleccionarItem(this);
        });
    });
});

function seleccionarItem(elemento) {
    // Desmarcar todos los elementos del menú
    var elementosMenu = document.querySelectorAll("#menu a");
    elementosMenu.forEach(function(item) {
        item.classList.remove("active");
        item.parentElement.parentElement.parentElement.classList.remove("liactive");
    });

    // Marcar el elemento liactive
    if(elemento.href === window.location.href) {
      elemento.classList.add("active");
      elemento.parentElement.parentElement.parentElement.classList.add("liactive");
    }
    // Guardar el elemento liactive en localStorage
    localStorage.setItem("selectedItem", elemento.getAttribute("href"));
}
